import { render, staticRenderFns } from "./columns-list-modal.vue?vue&type=template&id=0249ee6e&"
import script from "./columns-list-modal.vue?vue&type=script&lang=js&"
export * from "./columns-list-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports